<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="page-template">
<!--    <menu-list :hidden="tableOptions.menuListHidden"></menu-list>-->
    <div class="content-table-box">
      <search-form-template
        ref="searchFormTemp"
        :searchOptions="searchOptions"
        :toolConfig="searchAfterBtn"
        @btnCommon="btnCommon"
        @searchSubmit="searchSubmit"
        @clear="clearSearch"
      ></search-form-template>
      <table-template
        ref="tableTemp"
        :tableOptions="tableOptions"
        :detailColumns="detailColumns"
        :toolConfig="tableOperate"
        @btnCommon="btnCommon"
      ></table-template>
      <el-dialog
        :title="(id == 0?'添加':'编辑')+title"
        :visible.sync="dialogFormVisible"
        center
        width="800px"
        @close="closeDialog"
      >
        <form-template
          ref="formTemplate"
          v-if="dialogFormVisible"
          @success="formSuccess"
          @getDetailSuccess="getDetailSuccess"
          @submit="submit"
        >
          <template v-slot:fromSlot="data">
            <slot
              name="fromSlot"
              :column="data.column"
            ></slot>
          </template>
        </form-template>
      </el-dialog>
      <file-dialog
        :fileList="fileDialogData.fileList"
        :url="fileDialogData.url"
        :fileType="fileDialogData.type"
        @fileDialogClose="fileDialogClose"
      ></file-dialog>
    </div>
  </div>
</template>
<script>
  import fileDialog from "@/components/template/fileDialog";

  import menuList from "@/components/business/menuList";

  export default {
    components: {
      fileDialog,
      menuList,
    },
    props: {
      tableDefaultTool: {
        type: Array,
        default: () => {
          return [];
        },
      },
      tableOptions: {
        type: Object,
        default: () => {
          return {
            tableName: "table",
            stripe: false, //是否斑马纹
            border: false, //是否带边框
            height: 500, //表格高度 单位px
            fixed: false, //string, boolean  true, left, right true 表示固定在左侧 表格左侧或右侧一列固定
            showSelect: false, // 是否显示选择框
            template: "", //自定义列模板 传入模板名称
            indexShow: false, //是否显示索引
            indexMethod: (index) => {
              //自定义列索引
              return index;
            },
            columns: [
              {label: "ID", prop: "id", width: "100"},
              {label: "名称", prop: "name", width: "100"},
            ],
            url: "",
            param: {},
          };
        },
      },
      searchOptions: {
        type: Object,
        default: () => {
          return [];
        },
      },
      toolConfig: {
        type: Array,
        default: () => {
          return [];
        },
      },
      addColumns: {
        type: Object,
        default: () => {
          return {};
        },
      },
      editColumns: {
        type: Object,
        default: () => {
          return {};
        },
      },
      detailColumns: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        menuTool: [],
        //文件弹窗数据
        fileDialogData: {url: "", type: "", fileList: []},
        // 操作按钮
        currentMenu: {}, // 当前路由
        loading: false,
        title: "",
        searchAfterBtn: [], //搜索栏按钮
        searchParam: {},
        tableOperate: [],
        formType: {
          other: "other",
          insert: "insert", // 编辑状态
          update: "update", // 编辑状态
          search: "search", //搜索
        },
        formOptions: null,
        dialogFormVisible: false,
        id: 0,
      };
    },
    created() {
      this.title = document.title;
      this.setButton();
    },
    methods: {
      setButton() {
        this.tableOperate = [];
        this.searchAfterBtn = [];
        this.currentMenu = this.$utils.getUserMenu().filter(item=>{return item.url == this.$route.path})[0];
        if (this.currentMenu)
          this.menuTool = [
            ...(this.currentMenu.operationList || []),
            ...this.tableDefaultTool,
          ];
        //console.log(this.menuTool)
        this.menuTool &&
        this.menuTool.map((item) => {
          let tool = this.toolConfig.filter((t) => t.code == item.code);
          if (tool && tool.length > 0) {
            item.filter = tool[0].filter;
            item.callback = tool[0].callback;
          }
          if (item.type == this.$utils.buttonType.tableOperate) {
            if (item.code == "update" || item.code == "delete" || item.code == "details" || item.code == 'copy' || item.code == 'termination') {
              item.more = true;
            } else {
              item.more = false;
            }
            this.tableOperate.push(item);
          } else {
            this.searchAfterBtn.push(item);
          }
        });
      },
      //添加或编辑显示
      setFormOptions(operationType, id) {
        this.id = id || 0;
        this.dialogFormVisible = true;
        switch (operationType) {
          case this.formType.insert:
            this.formOptions = this.addColumns;
            break;
          case this.formType.update:
            this.formOptions = this.editColumns;
            break;
        }
        this.formOptions.formType = operationType;

        this.$nextTick(() => {
          //页面显示后操作
          this.$refs["formTemplate"] &&
          this.$refs["formTemplate"].initData(this.formOptions, id);
        });
      },
      formSuccess() {
        this.dialogFormVisible = false;
        this.operationSuccess();
      },
      getDetailSuccess(formModel) {
        this.formOptions.callback && this.formOptions.callback(formModel);
        this.$emit("getDetail", formModel);//把详情传给父组件
      },
      getTableSelectRow() {
        return this.$refs["tableTemp"].selectRow;
      },
      submit(data) {
        this.dialogFormVisible = false;
        this.$emit("submit", data);
      },
      // 关闭弹框
      closeDialog(){
        this.dialogFormVisible = false;
        this.$emit("closeDialog");
      },
      // 操作回调
      btnCommon(btnObj, data) {
        if (!btnObj.callback) {
          switch (btnObj.code) {
            case "detail":
              this.linkToDetail(data);
              break;
            case "insert":
              this.insert();
              break;
            case "update":
              this.update(data);
              break;
            default:
              console.log(btnObj.code);
          }
          this.$emit("btnCommon", btnObj,data);//点击后 将按钮 配置参数传回父组件
        } else {
          btnObj.callback && btnObj.callback(data);
        }
      },
      //重置 搜索清空
      clearSearch(formModel) {
        this.$refs["tableTemp"].clearSearch();
        this.$emit('searchReset',formModel)
      },
      //搜索
      searchSubmit(param) {
        this.$refs["tableTemp"].searchSubmit(param);
      },
      //添加或修改成功
      operationSuccess() {
        this.$refs["tableTemp"].operationSuccess();
      },
      insert() {
        this.setFormOptions("insert");
      },
      update(data) {
        this.setFormOptions("update", data.id);
      },
      //查看详情
      linkToDetail(data) {
        this.$router.push({
          path: `${this.$route.path}/detail?id=${data.id}`.replace("//", "/"),
        });
      },
      fileDialogClose() {
        this.fileDialogData = {url: "", type: "", fileList: []};
      },
      getSimpleParams() {
        return this.$refs.searchFormTemp.getSimpleParams();
      },
      getComplexParams() {
        return this.$refs.searchFormTemp.getComplexParams();
      },
      getCurrentParams(){
        return this.$refs.searchFormTemp.currentSearchParams;
      },
      getData() {
        return this.$refs["tableTemp"].getTableData();
      },
      getSearchParams() {
        Object.assign(
          this.searchParam,
          this.$refs.searchFormTemp.getSimpleParams()
        );
        Object.assign(
          this.searchParam,
          this.$refs.searchFormTemp.getComplexParams()
        );
        return this.searchParam;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/template/pageTemplate.vue